import { TrendingUp, TrendingDown, X } from "lucide-react";
import { Link } from "react-router-dom";

const SEVERITY = {
  critical: { dot: "bg-rose-500", text: "text-rose-700", bg: "bg-rose-50", label: "Critical" },
  warning: { dot: "bg-amber-500", text: "text-amber-700", bg: "bg-amber-50", label: "Warning" },
  info: { dot: "bg-emerald-500", text: "text-emerald-700", bg: "bg-emerald-50", label: "Positive" },
};

function timeAgo(iso) {
  const d = new Date(iso);
  const diff = Math.max(0, Date.now() - d.getTime());
  const h = Math.floor(diff / 3_600_000);
  if (h < 1) return `${Math.floor(diff / 60_000)}m ago`;
  if (h < 24) return `${h}h ago`;
  return `${Math.floor(h / 24)}d ago`;
}

export default function AlertItem({ alert, onDismiss, testId }) {
  const sev = SEVERITY[alert.severity] || SEVERITY.info;
  const Trend = alert.direction === "up" ? TrendingUp : TrendingDown;

  return (
    <div
      data-testid={testId}
      className="group flex items-center gap-4 px-4 py-3.5 border-b border-slate-100 hover:bg-slate-50/60 transition-colors"
    >
      <span className={`h-2 w-2 rounded-full ${sev.dot} shrink-0`} aria-hidden />

      <div className={`h-8 w-8 rounded-md ${sev.bg} ${sev.text} flex items-center justify-center shrink-0`}>
        <Trend className="h-4 w-4" />
      </div>

      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 mb-0.5">
          <span className="text-sm font-medium text-slate-900 truncate">{alert.metric}</span>
          <span className="text-[10px] uppercase tracking-[0.16em] font-semibold text-slate-400">·</span>
          <Link
            to={`/clients/${alert.client_id}`}
            className="text-xs text-slate-500 hover:text-slate-900 truncate"
            data-testid={`${testId}-client-link`}
          >
            {alert.client_name}
          </Link>
        </div>
        <div className="text-xs text-slate-500 truncate">{alert.message}</div>
      </div>

      <div className="flex items-center gap-3 shrink-0">
        <span className={`text-xs font-mono font-medium ${alert.direction === "up" ? "text-emerald-600" : "text-rose-600"} tabular-nums`}>
          {alert.change_pct > 0 ? "+" : ""}{alert.change_pct.toFixed(1)}%
        </span>
        <span className="text-[10px] text-slate-400 font-mono w-12 text-right">{timeAgo(alert.timestamp)}</span>
        {onDismiss && (
          <button
            onClick={() => onDismiss(alert)}
            data-testid={`${testId}-dismiss`}
            className="opacity-0 group-hover:opacity-100 transition-opacity text-slate-400 hover:text-slate-700"
            aria-label="Dismiss"
          >
            <X className="h-4 w-4" />
          </button>
        )}
      </div>
    </div>
  );
}
